import { VIEW_MODE_ICONS } from '@lumapps/designer-widget-settings/constants';
import { ViewModeType } from '@lumapps/designer-widget-settings/types';
import { WIDGET_BASE } from '@lumapps/widget-base/keys';

import { WIDGET_PLAYLIST } from './keys';
import { WidgetPlaylistProperties } from './types';

export const WIDGET_PLAYLIST_TYPE = 'playlist';
export const MAX_VIDEOS_PER_PLAYLIST = 9;

export const DEFAULT_WIDGET_PROPERTIES: WidgetPlaylistProperties = {
    playlist: undefined,
    playlistFieldOrder: ['title'],
    videoItemFieldOrder: ['duration', 'thumbnail', 'title'],
    maxNumber: MAX_VIDEOS_PER_PLAYLIST,
    viewModeVariant: 'grouped',
    viewPositionVariant: 'grid',
    itemsPerLine: 3,
    viewMode: 'grid',
    slideshowEnabled: false,
};

export enum ContainerPlaylistBlockVariant {
    grid = 'GRID',
    player = 'PLAYER',
}

export enum VIEW_POSITON_PLAYLIST_VARIANTS_VALUES {
    PLAYER = 'player',
    GRID = 'grid',
}

export const VIEW_MODE_PLAYLIST_VARIANTS: ViewModeType<string>[] = [
    {
        label: WIDGET_BASE.SETTINGS_VIEW_MODE_GRID,
        value: VIEW_POSITON_PLAYLIST_VARIANTS_VALUES.GRID,
        icon: VIEW_MODE_ICONS.GRID,
    },
    {
        label: WIDGET_PLAYLIST.SETTINGS_VIEW_MODE_PLAYER,
        value: VIEW_POSITON_PLAYLIST_VARIANTS_VALUES.PLAYER,
        icon: VIEW_MODE_ICONS.PLAYER,
    },
];
